// Helper notes may carry driver download links — make them clickable.
export const Linkified = ({ text }) => String(text || "").split(/(https?:\/\/[^\s)]+)/g).map((part, i) => /^https?:\/\//.test(part)
  ? <a key={i} href={part} target="_blank" rel="noreferrer" className="break-all text-[#4c9ffe] underline" data-testid="note-link">{part}</a> : part);
